require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconTextGen.tsx
var IconTextGen_exports = {};
__export(IconTextGen_exports, {
  default: () => IconTextGen_default
});
module.exports = __toCommonJS(IconTextGen_exports);

// src/assets/monochrome/textGen.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgTextGen = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7502 9.07495C13.4397 9.07495 13.1468 9.25417 13.039 9.54507L11.8916 12.6428L9.06931 13.5955C8.78324 13.692 8.5752 13.9464 8.5752 14.2499C8.5752 14.5535 8.78324 14.8079 9.06931 14.9044L11.8916 15.8571L13.039 18.9548C13.1468 19.2457 13.4397 19.4249 13.7502 19.4249C14.0606 19.4249 14.3536 19.2457 14.4613 18.9548L15.6088 15.8571L18.4311 14.9044C18.7171 14.8079 18.9252 14.5535 18.9252 14.2499C18.9252 13.9464 18.7171 13.692 18.4311 13.5955L15.6088 12.6428L14.4613 9.54507C14.3536 9.25417 14.0606 9.07495 13.7502 9.07495ZM12.9058 13.1198L13.7502 10.8404L14.5945 13.1198C14.6908 13.3796 14.8992 13.582 15.1617 13.6706L16.878 14.2499L15.1617 14.8293C14.8992 14.9179 14.6908 15.1203 14.5945 15.38L13.7502 17.6595L12.9058 15.38C12.8096 15.1203 12.6012 14.9179 12.3387 14.8293L10.6224 14.2499L12.3387 13.6706C12.6012 13.582 12.8096 13.3796 12.9058 13.1198Z", fill: "#676F7E" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.34961 5.00001C1.34961 2.98417 2.98377 1.35001 4.99961 1.35001H14.4996C15.9632 1.35001 17.1496 2.53645 17.1496 4.00001V9.50001C17.1496 9.85899 16.8586 10.15 16.4996 10.15C16.1406 10.15 15.8496 9.85899 15.8496 9.50001V4.00001C15.8496 3.25442 15.2452 2.65001 14.4996 2.65001H4.99961C3.70174 2.65001 2.64961 3.70214 2.64961 5.00001V16C2.64961 16.7456 3.25403 17.35 3.99961 17.35H9.99961C10.3586 17.35 10.6496 17.641 10.6496 18C10.6496 18.359 10.3586 18.65 9.99961 18.65H3.99961C2.53605 18.65 1.34961 17.4636 1.34961 16V5.00001Z", fill: "#676F7E" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.84961 6.00001C4.84961 5.64102 5.14062 5.35001 5.49961 5.35001H12.4996C12.8586 5.35001 13.1496 5.64102 13.1496 6.00001C13.1496 6.35899 12.8586 6.65001 12.4996 6.65001H5.49961C5.14062 6.65001 4.84961 6.35899 4.84961 6.00001Z", fill: "#676F7E" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.84961 9.50001C4.84961 9.14102 5.14062 8.85001 5.49961 8.85001H9.49961C9.85859 8.85001 10.1496 9.14102 10.1496 9.50001C10.1496 9.85899 9.85859 10.15 9.49961 10.15H5.49961C5.14062 10.15 4.84961 9.85899 4.84961 9.50001Z", fill: "#676F7E" })
] });
var textGen_default = SvgTextGen;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconTextGen.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconTextGen = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(textGen_default, {}) });
};
IconTextGen.displayName = "IconTextGen";
var IconTextGen_default = IconTextGen;
